import universal from 'react-universal-component';

export default universal(() => import('./Home'));



// WEBPACK FOOTER //
// ./src/app/views/Home/index.js